import { useGetAdvisorInsightsDataQuery } from '../../../common/insightsDataApi'
import { getDateRange } from '../../../shared/insights/utils/insightsTransforms'
import { INSIGHTS_CACHE_TTL_SECONDS } from '../../../shared/insights/utils/insightsUtils'
import { RANGE_TO_TIME_RANGE, RANGE_TO_USER_SCORE_RESULT_LIST_CHART, type RangeKey } from '../userScoreRange'

interface UseUserScoreResultDataOptions {
  enabled?: boolean
}

export const useUserScoreResultData = (accountId: string, userId: string, range: RangeKey, { enabled = true }: UseUserScoreResultDataOptions = {}) => {
  const { from, to } = getDateRange(RANGE_TO_TIME_RANGE[range])
  const skip = !enabled || !accountId || !userId

  const { data, isFetching, isLoading, isError } = useGetAdvisorInsightsDataQuery(
    { accountId, from, to, userIdList: [userId], charts: [RANGE_TO_USER_SCORE_RESULT_LIST_CHART[range]] },
    { skip, refetchOnMountOrArgChange: INSIGHTS_CACHE_TTL_SECONDS },
  )

  return {
    rows: data?.charts?.user_score_result_list ?? [],
    isFetching,
    isLoading,
    isError,
  }
}
